// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.media-table-container {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex: 1;
  min-height: 0;
  padding: 10px;
}

.media-header-layout {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  padding: 0 0 4px 0;
  width: 100%;
}

.media-table {
  display: flex;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  flex-direction: column;
  position: relative;
}

.media-table-inner {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 8px;
  border-radius: 4px;
  position: relative;
}

.media-table-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 12px;
  align-items: stretch;
  align-content: start;
  justify-items: stretch;
  box-sizing: border-box;
}

.media-table-loading-container {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  z-index: 1;
}

.media-table-loading-lyt {
  padding: 12px 16px;
  border-radius: 4px;
  font-size: 0.95rem;
  font-weight: 400;
  box-shadow: 1px 2px 3px rgba(0, 0, 0, 0.2);
}

.media-table-footer-loading {
  flex-shrink: 0;
  padding-right: 12px;
  font-size: 0.9rem;
  font-weight: 500;
  letter-spacing: 0.01em;
}

.sort-by-layout {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 220px;
}

.media-element-container {
  min-width: 0;
  max-width: 240px;
  min-height: 220px;
  max-height: 280px;
  border-radius: 3px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  /* box-shadow: 2px 1px 4px rgba(0,0,0,0.25); */
  overflow: hidden;
}

.media-element-thumbnail-frame {
  width: 100%;
  max-width: 100%;
  height: 112px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  box-sizing: border-box;
  flex: 0 0 112px;
}

.media-element-thumbnail {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
}

.media-element-text {
  font-size: 13px;
  padding: 2px 0 0 0;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: none;
  white-space: nowrap;
  overflow-wrap: normal;
  word-break: normal;
}

.media-element-lyt {
  width: 100%;
  min-width: 0;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  justify-content: flex-start;
  padding: 4px 4px 0 4px;
  box-sizing: border-box;
}

.media-element-lbl-lyt {
  width: 100%;
  min-width: 0;
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  padding: 4px 0 4px 0;
  box-sizing: border-box;
}

.media-element-lbl-row {
  display: flex;
  width: 100%;
  height: 20px;
  flex: 0 0 20px;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.element-qb-container {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: start;
  gap: 3px;
}

.element-menu-selector {
  display: flex;
  max-width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  margin-right: 4px;
}

.element-menu-container {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 4px;
  box-sizing: border-box;
}

.element-menu-item {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 6px;
}

.element-menu-divider {
  opacity: 0.5;
  width: auto;
  height: 2px;
  box-sizing: border-box;
  margin: 0 12px;
  align-self: stretch;
}

.media-element-thb-placeholder {
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  padding: 2px;
  box-sizing: border-box;
}

.modal-viewer-parent-frame {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  outline: none;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 11px 15px -7px,
  rgba(0, 0, 0, 0.14) 0px 24px 38px 3px,
  rgba(0, 0, 0, 0.12) 0px 9px 46px 8px;
}

#modal-container {
  position: relative;
  font-size: 2.5em;
  background-color: black;
}

#modal-container:fullscreen {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

#video-player {
  display: flex;
  justify-content: center;
  align-items: center;
  object-fit: contain;
}

.media-mode-no-fs {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
  display: block;
}

.media-mode-fs {
  width: 100vw;
  height: 100vh;
  object-fit: contain;
  object-position: center;
  display: block;
}

#wm-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* temp style to represent a folder selected element */
.chosen-element {
  border: 2px solid orange !important;
  box-shadow: 0 0 8px orange !important;
}

.media-element-error {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 16px;
  text-align: center;
}

.modal-viewer-footer {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-viewer-label-lyt {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-left: 8px;
}

.modal-viewer-status-lyt {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px 15px;
  border-radius: 4px;
  box-sizing: border-box;
}

#detailed-media-modal-media-pane {
  padding: 0 4px;
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: black;
  position: relative;
}

#detailed-media-modal-content {
  flex: 1;
  min-height: 0;
  height: 100%;
  position: relative;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/styles/mediaStyles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,OAAO;EACP,aAAa;EACb,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,oBAAoB;EACpB,oBAAoB;EACpB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,2BAA2B;EAC3B,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb;;sCAEoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,sDAAsD;AACtD;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".media-table-container {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  flex: 1;\n  min-height: 0;\n  padding: 10px;\n}\n\n.media-header-layout {\n  display: flex;\n  justify-content: flex-end;\n  gap: 16px;\n  padding: 0 0 4px 0;\n  width: 100%;\n}\n\n.media-table {\n  display: flex;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n  flex-direction: column;\n  position: relative;\n}\n\n.media-table-inner {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 8px;\n  border-radius: 4px;\n  position: relative;\n}\n\n.media-table-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 12px;\n  align-items: stretch;\n  align-content: start;\n  justify-items: stretch;\n  box-sizing: border-box;\n}\n\n.media-table-loading-container {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n  z-index: 1;\n}\n\n.media-table-loading-lyt {\n  padding: 12px 16px;\n  border-radius: 4px;\n  font-size: 0.95rem;\n  font-weight: 400;\n  box-shadow: 1px 2px 3px rgba(0, 0, 0, 0.2);\n}\n\n.media-table-footer-loading {\n  flex-shrink: 0;\n  padding-right: 12px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  letter-spacing: 0.01em;\n}\n\n.sort-by-layout {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  width: 220px;\n}\n\n.media-element-container {\n  min-width: 0;\n  max-width: 240px;\n  min-height: 220px;\n  max-height: 280px;\n  border-radius: 3px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  position: relative;\n  /* box-shadow: 2px 1px 4px rgba(0,0,0,0.25); */\n  overflow: hidden;\n}\n\n.media-element-thumbnail-frame {\n  width: 100%;\n  max-width: 100%;\n  height: 112px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  box-sizing: border-box;\n  flex: 0 0 112px;\n}\n\n.media-element-thumbnail {\n  width: 100%;\n  height: 100%;\n  display: block;\n  object-fit: contain;\n}\n\n.media-element-text {\n  font-size: 13px;\n  padding: 2px 0 0 0;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-transform: none;\n  white-space: nowrap;\n  overflow-wrap: normal;\n  word-break: normal;\n}\n\n.media-element-lyt {\n  width: 100%;\n  min-width: 0;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  gap: 8px;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 4px 4px 0 4px;\n  box-sizing: border-box;\n}\n\n.media-element-lbl-lyt {\n  width: 100%;\n  min-width: 0;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 4px 0 4px 0;\n  box-sizing: border-box;\n}\n\n.media-element-lbl-row {\n  display: flex;\n  width: 100%;\n  height: 20px;\n  flex: 0 0 20px;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n}\n\n.element-qb-container {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: start;\n  gap: 3px;\n}\n\n.element-menu-selector {\n  display: flex;\n  max-width: 40px;\n  height: 40px;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  margin-right: 4px;\n}\n\n.element-menu-container {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  padding: 4px;\n  box-sizing: border-box;\n}\n\n.element-menu-item {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 6px;\n}\n\n.element-menu-divider {\n  opacity: 0.5;\n  width: auto;\n  height: 2px;\n  box-sizing: border-box;\n  margin: 0 12px;\n  align-self: stretch;\n}\n\n.media-element-thb-placeholder {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  justify-content: center;\n  align-items: center;\n  padding: 2px;\n  box-sizing: border-box;\n}\n\n.modal-viewer-parent-frame {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  outline: none;\n  box-shadow: rgba(0, 0, 0, 0.2) 0px 11px 15px -7px,\n  rgba(0, 0, 0, 0.14) 0px 24px 38px 3px,\n  rgba(0, 0, 0, 0.12) 0px 9px 46px 8px;\n}\n\n#modal-container {\n  position: relative;\n  font-size: 2.5em;\n  background-color: black;\n}\n\n#modal-container:fullscreen {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n#video-player {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  object-fit: contain;\n}\n\n.media-mode-no-fs {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  object-position: center;\n  display: block;\n}\n\n.media-mode-fs {\n  width: 100vw;\n  height: 100vh;\n  object-fit: contain;\n  object-position: center;\n  display: block;\n}\n\n#wm-container {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* temp style to represent a folder selected element */\n.chosen-element {\n  border: 2px solid orange !important;\n  box-shadow: 0 0 8px orange !important;\n}\n\n.media-element-error {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  padding: 16px;\n  text-align: center;\n}\n\n.modal-viewer-footer {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.modal-viewer-label-lyt {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  margin-left: 8px;\n}\n\n.modal-viewer-status-lyt {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 30px 15px;\n  border-radius: 4px;\n  box-sizing: border-box;\n}\n\n#detailed-media-modal-media-pane {\n  padding: 0 4px;\n  flex: 1 1 auto;\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: black;\n  position: relative;\n}\n\n#detailed-media-modal-content {\n  flex: 1;\n  min-height: 0;\n  height: 100%;\n  position: relative;\n  overflow: hidden;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
